/* ==========================================================================
   MAISON NOIR & CO — Finale
   The one dark moment of the page gets one piece of behaviour: a warm light
   that follows the pointer across the band, lagging behind it on the house
   curve so it reads as a lamp being carried, not a cursor sticker.

   Everything else in the section is CSS. This is pure enhancement:
   - nothing here is required for the section to render or to be readable
   - it never runs under prefers-reduced-motion
   - it never runs on touch-only devices (there is no pointer to follow)
   ========================================================================== */
(function () {
  'use strict';

  var SELECTOR = '[data-mn-finale]';

  function canRun() {
    if (!window.matchMedia) return false;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function bind(root) {
    if (root.mnFinale) return;
    root.mnFinale = true;

    var frame = null;
    var pending = null;

    function paint() {
      frame = null;
      if (!pending) return;
      root.style.setProperty('--px', pending.x + 'px');
      root.style.setProperty('--py', pending.y + 'px');
    }

    root.addEventListener('pointermove', function (event) {
      var rect = root.getBoundingClientRect();
      pending = { x: event.clientX - rect.left, y: event.clientY - rect.top };
      if (frame === null) frame = window.requestAnimationFrame(paint);
    });

    root.addEventListener('pointerenter', function () {
      root.classList.add('is-lit');
    });

    root.addEventListener('pointerleave', function () {
      root.classList.remove('is-lit');
    });
  }

  function init(scope) {
    if (!canRun()) return;
    var roots = (scope || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < roots.length; i++) bind(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
